<div class="status" [ngClass]="cssClass">
    <div class="status_icon">
      <i
        class="far"
        [ngClass]="{
          'fa-hourglass': status === 'Pending' || status === 'Processing' || status === 'Drafts' || status === 'Draft' || status==='Acknowledged' || status === 'In_transit' || status=== 'Unshipped' || status=== 'PENDING_SHIPMENT_DETAILS',
          'fa-check-circle': status === 'Shipped' || status === 'Delivered' || status === 'Receiving',
          'fa-times-circle': status === 'Cancelled' || status==='Canceled' || status === 'Closed' || status==='CLOSED' || status === 'Deleted' || status==='IN_TRANSIT',
          'fa-clock': status ==='Working'
        }"
      ></i>
    </div>
    {{ status }}
  </div>